import { render, staticRenderFns } from "./OnsiteTemplateEditor.vue?vue&type=template&id=c4b2de6c&scoped=true"
import script from "./OnsiteTemplateEditor.vue?vue&type=script&lang=js"
export * from "./OnsiteTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./OnsiteTemplateEditor.vue?vue&type=style&index=0&id=c4b2de6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b2de6c",
  null
  
)

export default component.exports